import type { User } from 'firebase/auth';

export const BOOKING_CONTACT_REQUIRED_MESSAGE =
    'This app requires both an email address and a phone number to reserve tee times.';

export const BOOKING_NAME_REQUIRED_MESSAGE =
    'This app requires your first and last name to reserve tee times.';

export function getBookingEmail(user: User | null | undefined, userData: { email?: string } | null | undefined): string {
    return (user?.email || userData?.email || '').trim();
}

export function getBookingPhone(userData: { phone?: string } | null | undefined): string {
    return (userData?.phone || '').trim();
}

export function hasBookingContactInfo(
    user: User | null | undefined,
    userData: { email?: string; phone?: string } | null | undefined
): boolean {
    return !!getBookingEmail(user, userData) && !!getBookingPhone(userData);
}

export function hasBookingNameFields(
    userData: { firstName?: string; lastName?: string } | null | undefined
): boolean {
    return !!(userData?.firstName || '').trim() && !!(userData?.lastName || '').trim();
}

export function getBookingProfileBlockReason(
    user: User | null | undefined,
    userData: { email?: string; phone?: string; firstName?: string; lastName?: string } | null | undefined
): string | null {
    if (!hasBookingContactInfo(user, userData)) {
        return BOOKING_CONTACT_REQUIRED_MESSAGE;
    }
    if (!hasBookingNameFields(userData)) {
        return BOOKING_NAME_REQUIRED_MESSAGE;
    }
    return null;
}

export function isBookingProfileComplete(
    user: User | null | undefined,
    userData: { email?: string; phone?: string; firstName?: string; lastName?: string } | null | undefined
): boolean {
    return getBookingProfileBlockReason(user, userData) === null;
}

export function bookingProfileBlockState(message: string) {
    return { bookingContactMessage: message };
}

/** @deprecated Use bookingProfileBlockState */
export function bookingContactProfileState() {
    return bookingProfileBlockState(BOOKING_CONTACT_REQUIRED_MESSAGE);
}
